import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {FILTER_BY_NO_BARCODE, FILTER_BY_NO_PROSOFT_ID} from "../constants";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

export default function FilterSelect({onSelect}) {
    const classes = useStyles();
    const [filter, setFilter] = React.useState(FILTER_BY_NO_BARCODE);

    const handleChange = ({target}) => {

        setFilter(target.value);
        onSelect(target.value);

    };

    return (
        <div>
            <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">Filtre</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={filter}
                    onChange={handleChange}
                >
                    <MenuItem value={FILTER_BY_NO_BARCODE}>Pas de code Bar</MenuItem>
                    <MenuItem value={FILTER_BY_NO_PROSOFT_ID}>Pas de Ref Prosof</MenuItem>
                </Select>
            </FormControl>

        </div>
    );
}
